import CheckboxTemplate from '../../html/components/checkbox.html'
import CheckboxGroupTemplate from '../../html/components/checkbox-group.html'

import Component from '../shared/component'
import Relation, {HasMany, MemberOf} from '../shared/mixins/relation'

import {Interactive} from './interactive'
import {Icon} from './icon'
import {FormControlMixin} from './form'

const checkboxGroup = Relation()

export const Checkbox = Component('v-checkbox', {
  model: {
    prop: 'checked',
    event: 'change'
  },
  components: [
    Interactive,
    Icon
  ],
  mixins: [
    MemberOf(checkboxGroup, 'group')
  ],
  template: CheckboxTemplate,
  props: {
    value: {
      default: null
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      active: this.checked
    }
  },
  watch: {
    checked () {
      this.active = this.checked
    },

    active () {
      this.$emit('change', this.active)
    }
  },
  methods: {
    select () {
      if (!this.active) {
        this.active = true
      }
    },

    deselect () {
      if (this.active) {
        this.active = false
      }
    },

    toggle () {
      if (!this.active) {
        this.select()
      } else {
        this.deselect()
      }
    }
  }
})

export const CheckboxGroup = Component('v-checkbox-group', {
  mixins: [
    HasMany(checkboxGroup, 'checkboxes'),
    FormControlMixin('checkbox')
  ],
  template: CheckboxGroupTemplate,
  props: {
    name: {
      type: String,
      default: null
    },
    value: {
      type: Array,
      default () {
        return []
      }
    }
  },
  watch: {
    active () {
      this.checkboxes.forEach(checkbox => {
        if (this.active.includes(checkbox.value)) {
          checkbox.select()
        } else {
          checkbox.deselect()
        }
      })
    },

    checkboxes () {
      this.checkboxes.forEach(checkbox => {
        if (this.active.length === 0 && checkbox.active) {
          this.select(checkbox.value)
        }

        if (this.active.includes(checkbox.value)) {
          checkbox.select()
        } else {
          checkbox.deselect()
        }

        checkbox.$on('change', active => active
          ? this.select(checkbox.value)
          : this.deselect(checkbox.value)
        )
      })
    }
  },
  methods: {
    select (value) {
      if (!this.active.includes(value)) {
        this.active.push(value)
      }
    },

    deselect (value) {
      if (this.active.includes(value)) {
        this.active.splice(this.active.indexOf(value), 1)
      }
    }
  }
})
